<ng-container *ngIf="list && list['data'] && list['data'].length > 0">
  <label mat-dialog-title class="uk-text-title">{{ list['title'] }}</label>
  
  <mat-dialog-content class="content-global">
    <app-data-table
    type="securityStockByHierarchy"
    [data]="list['data']"
    size="large"
    (showDialog)="actionHeader($event)"
    (iconActionHeader)="actionHeader($event)"
    ></app-data-table>
  </mat-dialog-content>
  
  <mat-dialog-actions align="center">
    <button
      mat-flat-button
      id="cancel"
      class="border-box b-s m-4 button-success"
      (click)="onNoClick()"
      type="button"
    >
      Salir
    </button>
  </mat-dialog-actions>
  
  <button id="closeAddAddress" mat-button mat-dialog-close class="dialog-close">
    <mat-icon>close</mat-icon>
  </button>

</ng-container>  
